import React, { Component } from 'react';
import { OptionDropdown, Highlighter } from 'framework-ui-components';
import { abilitaSostitutoImposta, disabilitaSostitutoImposta } from 'apis/sostitutiApi';


import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import Servizi from 'enums/Servizi';
import ModaleSostituto from './ModaleSostituto';
import checkServizio from '../../helpers/checkServizio';

class RigaSostituto extends Component {
    state = {
      mostraModaleSostituti: false,
    }

    chiudiModaleSostituto = () => {
      this.setState({
        mostraModaleSostituti: false,
      });
      this.props.additionalRowData.ricarica && this.props.additionalRowData.ricarica();
    }

    modifica = () => {
      this.setState({
        mostraModaleSostituti: true,
      });
    }

    dismetti = () => {
      disabilitaSostitutoImposta(this.props.item.IdSostituto)
        .then((res) => {
          if (res.Success) {
            SnackbarManager.notifySuccess(`Sostituto di imposta ${this.props.item.Denominazione} disabilitato`);
            this.props.additionalRowData.ricarica && this.props.additionalRowData.ricarica();
          } else {
            SnackbarManager.notifyError(res.DetectedProblems);
          }
        });
    }

    abilita = () => {
      abilitaSostitutoImposta(this.props.item.IdSostituto)
        .then((res) => {
          if (res.Success) {
            SnackbarManager.notifySuccess(`Sostituto di imposta ${this.props.item.Denominazione} abilitato`);
            this.props.additionalRowData.ricarica && this.props.additionalRowData.ricarica();
          } else {
            SnackbarManager.notifyError(res.DetectedProblems);
          }
        });
    }

    visualizzaModificaSostituto = () => {
      this.setState({
        mostraModaleSostituti: true,
      });
    }

    render() {
      const {
        additionalRowData,
        item,
        servizioAttivo,
      } = this.props;
      const {
        mostraModaleSostituti,
      } = this.state;

      return (
        <tr key={item.IdSostituto} className={item.Dismesso && 'rowDisabled'}>
          <td onClick={this.visualizzaModificaSostituto} className="w-180">
            <Highlighter text={item.CodiceFiscale} value={additionalRowData.searchTerm} />
          </td>
          <td onClick={this.visualizzaModificaSostituto}>
            <Highlighter text={item.Denominazione} value={additionalRowData.searchTerm} />
          </td>
          <td onClick={this.visualizzaModificaSostituto}>{item.CodiceSede}</td>
          <td onClick={this.visualizzaModificaSostituto}>{item.Telefono}</td>
          <td onClick={this.visualizzaModificaSostituto}>{item.Fax}</td>
          <td onClick={this.visualizzaModificaSostituto}>{item.EMail}</td>

          <td>
            {
              !item.Centralizzato
                        && servizioAttivo
                        && (
                          <OptionDropdown>
                            {
                              !item.Centralizzato
                                    && <OptionDropdown.Item onClick={this.modifica}>Modifica</OptionDropdown.Item>
                            }
                            {
                              item.Dismesso
                                    && (
                                      <OptionDropdown.Item
                                        onClick={this.abilita}
                                      >Abilita
                                      </OptionDropdown.Item>
                                    )
                            }
                            {
                              !item.Dismesso
                                    && (
                                      <OptionDropdown.Item
                                        onClick={this.dismetti}
                                      >Disabilita
                                      </OptionDropdown.Item>
                                    )
                            }
                          </OptionDropdown>
                        )
            }
          </td>
          {
            mostraModaleSostituti
                    && (
                      <ModaleSostituto
                        visualizza={!servizioAttivo}
                        ufficioSelezionato={additionalRowData.ufficio}
                        idSostituto={item.IdSostituto}
                        showModal={mostraModaleSostituti}
                        onAnnulla={this.chiudiModaleSostituto}
                        annoSelezionato={additionalRowData.anno}
                      />
                    )
          }
        </tr>
      );
    }
}

export default checkServizio(Servizi['7OL'])(RigaSostituto);
